import FloatBall from "@/components/FloatBall";
import CustomBlueCheckoutSuccess from "@/views/components/custom-blue/CheckoutSuccess.vue";
import ThemePaymentAccountEntryPage from "@/views/components/theme/PaymentAccountEntryPage.vue";
import ThemeCopyPayPage from "@/views/components/theme/ThemeCopyPayPage.vue";
import {
    getCountryLanguageConfig,
    getLanguageLabel,
    getNextLanguage,
    getSupportedCountryLanguages,
    isCountryLanguageSwitchEnabled,
    setI18nLanguage,
    setLanguageByCountry,
} from "@/utils/languageAdapter";
import {formatMoney, throttleClick} from "@/utils";
import paymentAccountPopupCopy from "@/mixins/paymentAccountPopupCopy";
import themeMixin from "@/mixins/theme";
import { applyCustomBlueSuccessDebug } from "@/themes/custom-blue/debug";
import {driver} from "driver.js";
import "driver.js/dist/driver.css";

export default {
    name: "pay",
    mixins: [paymentAccountPopupCopy, themeMixin],
    props: {
        pageData: Object,
    },
    components: {FloatBall, CustomBlueCheckoutSuccess, ThemePaymentAccountEntryPage, ThemeCopyPayPage},
    watch: {
        pageData(val) {
            console.log("watch", val);
            this.repaymentData = val;
            this.updateCode();
            this.getCardInfo();
        },
    },
    computed: {
        floatBallImageKey() {
            const currentLang = this.$i18n.locale;
            const countryConfig = getCountryLanguageConfig(this.countryInfo?.enName);

            if (Object.prototype.hasOwnProperty.call(countryConfig, currentLang)) {
                return countryConfig[currentLang] || "";
            }
            return countryConfig[countryConfig.default] || "";
        },
        floatBallImg() {
            const imageKey = this.floatBallImageKey;
            if (!imageKey) return "";

            const themeFloatBallMap = this.themeImg('floatBallMap');
            if (themeFloatBallMap?.[imageKey]) return themeFloatBallMap[imageKey];

            try {
                return require(`@/components/FloatBall/${imageKey}.png`);
            } catch (error) {
                return "";
            }
        },
        floatBallText() {
            if (this.floatBallImageKey) return "";
            return getLanguageLabel(
                getNextLanguage(this.$i18n.locale, this.supportedLanguages)
            );
        },
        //国家信息
        countryInfo() {
            return this.repaymentData?.configData?.countryInfoVO;
        },
        countryInfoLogo() {
            if (["GH"].includes(this.countryInfo?.enName)) {
                return require(`@/assets/payLogo2.png`);
            } else {
                return require(`@/assets/payLogo.png`);
            }
        },
        //是否开启语言切换悬浮球
        isShowBall() {
            return isCountryLanguageSwitchEnabled(this.countryInfo?.enName);
        },
        // 支持的语言列表
        supportedLanguages() {
            return getSupportedCountryLanguages(this.countryInfo?.enName);
        },
        //还款账号长度
        phoneMaxLength() {
            if (this.countryInfo?.enName === "EG") {
                return 11;
            }
            if (["BF", "TD", "ML", "NE", "SL"].includes(this.countryInfo?.enName)) {
                return 9;
            }
            return 10;
        },
        currentBankInfo() {
            return this.operatorList.find(
                (v) => v.value === this.repaymentData?.paymentData?.bankCode
            );
        },
        // 格式化后的支付金额，根据当前选中的银行 decimalPlaces 格式化
        formattedPaymentAmount() {
            const amount = this.repaymentData?.paymentData?.amount;
            if (amount == null) return amount;
            return this.formatDecimal(
                String(amount),
                this.currentBankInfo?.decimalPlaces
            );
        },
        // 处理 tipsContent，替换模板中的占位符
        processedTipsContent() {
            const tipsContent = this.repaymentData?.cardData?.tipsContent;
            if (!tipsContent) return '';
            const amount = this.repaymentData?.cardData?.amount || '';
            const account = this.repaymentData?.cardData?.accountNumber || '';
            const agent = this.repaymentData?.cardData?.agentAccountId || '';
            return this.replaceTemplate2(tipsContent, amount, account, agent);
        },
        isHideTextarea() {
            const bankName = this.repaymentData?.cardData?.bankName;
            if (this.countryInfo?.enName === "NE") {
                if (!bankName) return false;
                const formatted = this.formatBankName ? this.formatBankName(bankName) : bankName;
                return String(formatted).toLowerCase() === "orange";
            }
            if (this.countryInfo?.enName === "EG") {
                return bankName && this.formatBankName(bankName).toLowerCase() == "orange";
            }
            return false;
        },
        showPaymentAccountEntryPage() {
            return this.isPaymentAccountEntryPageTheme && this.paymentAccountShow;
        },
        showThemeCopyPayPage() {
            return this.isPaymentAccountEntryPageTheme && !this.paymentAccountShow;
        },
    },
    data() {
        return {
            setTimeoutID: undefined,
            repaymentData: {},

            hr: undefined,
            min: undefined,
            sec: undefined,

            operatorList: [
                // {
                //     name: "WAVE",
                //     value: "BF0001",
                //     logo: require("@/assets/CI/wave.png"),
                //     isSelect: false
                // },
                // {
                //     name: "ORANGE",
                //     value: "BF0003",
                //     logo: require("@/assets/CI/orange.png"),
                //     isSelect: false
                // },
                // {
                //     name: "MOOV",
                //     value: "BF0004",
                //     logo: require("@/assets/CI/moov.png"),
                //     isSelect: false
                // },
                // {
                //     name: "TELECEL",
                //     value: "BF0002",
                //     logo: require("@/assets/CI/telecel.png"),
                //     isSelect: false
                // },
            ],

            transactionIdTemplate: "",
            transactionIdTemplateShow: false,
            transactionId: "",
            isSubmitTransactionId: false,
            paymentAccount: "",
            userSubmitAccountNumber: "",
            userSubmitOperator: "",
            editAccountNumber: "",

            paymentAccountShow: false,
            paymentAccountVerifyShow: false,
            editAccountShow: false,
            editAccountConfirmShow: false,
            collectionShow: false,
            collectionDetailShow: false,

            collectionDataStep: -1,
            collectionData: {
                transactionNums: 0,
                collectedAmount: 0,
                collectDetails: [],
            },

            timerOut: 3, // 弹窗确认按钮显示几秒
            popCommitText: "", // 按钮展示文案

            isInitVerify: false,
            intervalID: "",

            refreshNum: 0,
            showError: false,
            showCustomBlueSuccessPage: false,

            driver: null,
            isShowDriver: false,

            showPopover: false,
        };
    },
    methods: {
        formatMoney,
        replaceTemplate(template, a, b, c) {
            return template.replace(/amount|account|agent/g, (match) => {
                if (match === "amount") return a;
                if (match === "account") return b;
                if (match === "agent") return c;
                return match; // 非标记内容保持不变
            });
        },
        replaceTemplate2(template, a, b, c) {
            return template.replace(/@amount|@account|@agent/g, (match) => {
                if (match === "@amount") return a;
                if (match === "@account") return b;
                if (match === "@agent") return c;
                return match; // 非标记内容保持不变
            });
        },
        onDial() {
            window.location.href = `tel://${encodeURIComponent(
                this.getDial()
            )}`;
            // window.location.href = `tel://${this.getDial()}`;
        },
        getDial() {
            const amount = this.repaymentData.cardData.amount;
            const accountNumber = this.repaymentData.cardData.accountNumber;
            const agent = this.repaymentData.cardData.agentAccountId;
            const cmdCode = this.repaymentData.cardData.cmdCode;
            return `${this.replaceTemplate(cmdCode, amount, accountNumber, agent)}`;
        },
        async setLanguageBasedOnCountry(countryCode = "EN") {
            setLanguageByCountry(countryCode, this);
        },
        getInputPlaceholder() {
            const bankName = this.repaymentData?.cardData?.bankName;
            if (this.countryInfo?.enName === "BF") {
                if (bankName && this.formatBankName(bankName).toLowerCase() === "wave") {
                    return "AQ2*********C3XG";
                } else if (bankName && this.formatBankName(bankName).toLowerCase() === "telecel") {
                    return "Cher client, vous avez transfere xx.xx FCFA au 226****4567 - XXX le xx/xx/20xx 03:05:04. Frais  0.00 FCFA. Votre solde est de xx.xx FCFA ID de transaction est CFO9***Y6B. Pour toute reclamation contactez le 888. Telecel Money";
                } else if (bankName && this.formatBankName(bankName).toLowerCase() === "orange") {
                    return "Cher client, vous avez transfere xx.xx FCFA au numero ****1543,xx-xx. Votre solde est de  xx.0 FCFA. ID Trans: PP250624.****.19362705. Pour toute reclamation contactez par appel le 127 ou whatsapp 07000121. Orange Money BF";
                } else if (bankName && this.formatBankName(bankName).toLowerCase() === "moov") {
                    return "Transfert National d'argent réussi pour xx xx Numéro: 226****7539 Montant: xx FCFA Frais: Frais:0,00 FCFA FCFA Total:xx FCFA Date: xx/xx/20xx 10H25  TID: PP250624.****.F11412  Solde: xxx FCFA";
                } else {
                    return "AQ2*********C3XG";
                }
            } else if (this.countryInfo?.enName === "BJ") {
                if (bankName && this.formatBankName(bankName).toLowerCase() == "moov") {
                    return 'Vous avez envoye ** FCFA a xxx xxx 229019****044.Motif:"1 "le xx/xx/20xx xx:xx:xx.Frais de transaction: 0 FCFA.Votre nouveau solde Moov Money est de ** FCFA. Ref:030****9837. Profite des packs Moov Money pour des transactions sans frais, Tape vite *855*12# pour l\'activer !!!';
                } else {
                    return "Transfert **F a xxx xxx(229015****744)20xx-xx-xx xx:xx:xx Frais:xxF Solde:**F Ref:1ID: 1006****188";
                }
            } else if (this.countryInfo?.enName === "GH") {
                if (bankName && this.formatBankName(bankName).toLowerCase() === "mtn") {
                    return "Payment made for GHS xxx to xxx xxx. Current Balance: GHS xxx. Available Balance: GHS xxx. Reference: 186708xxxxxxx881472. Transaction ID: 489xxxxx689. Fee charged: GHS xxx TAX charged: GHS xxx."
                } else {
                    return "0000xxxxxxxx1916 Confirmed. GHS xxx sent to 050xxxx118 - xxx xxx on 0000-00-00 at 00:00:00. Your Telecel Cash balance is GHSxxx. You were charged GHSxxx. Your E-levy charge is GHSxxx. E-levy now reduced to 1%. Do more with Telecel Cash! Reference: 187398xxxxxxx507008"
                }
            } else if (this.countryInfo?.enName === "ZM") {
                if (bankName && this.formatBankName(bankName).toLowerCase() === "mtn") {
                    return "Y'ello. Payment of ZMW xxx to AIRTEL NFS successful at 0000-00-00 00:00:00.Message:- Wezi Kaluba,xxx. Your new balance: xxx ZMW.Financial Transaction ID: xxx. Enjoy quicker & easier transactions on the MoMo app. Visit https://linktr.ee/MTNZambia to download."
                } else {
                    return "Y'ello. Payment of ZMW xxx to AIRTEL NFS successful at 0000-00-00 00:00:00.Message:- Wezi Kaluba,xxx. Your new balance: xxx ZMW.Financial Transaction ID: xxx. Enjoy quicker & easier transactions on the MoMo app. Visit https://linktr.ee/MTNZambia to download."
                }
            } else if (this.countryInfo?.enName === "CM") {
                if (bankName && this.formatBankName(bankName).toLowerCase() == "mtn") {
                    return "Transfert de xxx FCFA effectue avecsucces a XXX(237xxxxx7986)le xx-xx-xx 23:59:59FRAIS 54 FCFA. transaction ld:126xxxxx003. Reference: hi. Nouveausolde est:xxx FCFA. Souscrivez aMoMo Helep avec *126*61# etcompletez vos transactions :memesans argent, initiez vos paiements ettransferts et MoMo completera lemontant."
                } else {
                    return "Successful transfer from 659992634ABEGON to 655631823 ILINAHN.Transaction lD:PP250528.0948.C35153,Transactionamount: 254 FCFA, Charges: 54 FCFACommission: 0 FCFA, Net debitamount: 308 FCFA, New balance: 9220FCFA."
                }
            } else if (this.countryInfo?.enName === "KE") {
                return "payment SMS example:\n" +
                    "SKL7L8SIDT Confirmed. Ksh320.00 sent to xx xxx 074xxx6688 on 11/11/22 at 2:10 PM. ......";
            } else if (this.countryInfo?.enName === "SN") {
                if (bankName && this.formatBankName(bankName).toLowerCase() == "orange") {
                    return "Le transfert de xxx FCFA vers le 070xxx2946 est un succes. Frais 0.00 FCFA.Solde:xxx FCFA. Reference: PP250302.xxxx.D93058. Orange Money CI vous remercie"
                } else if (bankName && this.formatBankName(bankName).toLowerCase() == "mtn") {
                    return "Vous avez transfere xxx FCFA au 225059xxx4601. Date: xx-xx-2025 23:59:59. Solde actuel: xxx FCFA. ID Tr: 121xxxx6660. Pour annuler, tapez*133#, option 3 puis 6. Tous vos transferts d'argent sont gratuits avec MoMo"
                } else if (bankName && this.formatBankName(bankName).toLowerCase() == "wave") {
                    return "Veuillez entrer TransactionlD"
                }
            } else if (this.countryInfo?.enName === "CI") {
                if (bankName && this.formatBankName(bankName).toLowerCase() == "orange") {
                    return "Le transfert de xxx FCFA vers le 070xxx2946 est un succes. Frais 0.00 FCFA.Solde:xxx FCFA. Reference: PP250302.xxxx.D93058. Orange Money CI vous remercie"
                } else if (bankName && this.formatBankName(bankName).toLowerCase() == "mtn") {
                    return "Vous avez transfere xxx FCFA au 225059xxx4601. Date: xx-xx-2025 23:59:59. Solde actuel: xxx FCFA. ID Tr: 121xxxx6660. Pour annuler, tapez*133#, option 3 puis 6. Tous vos transferts d'argent sont gratuits avec MoMo"
                } else if (bankName && this.formatBankName(bankName).toLowerCase() == "wave") {
                    return "Veuillez entrer TransactionlD"
                }
            } else if (this.countryInfo?.enName === "ID") {
                return `payment SMS example:
BL6XXXXXNFA Imethibitishwa TshXXX imetumwa kwa 255XXXXXX160 - MATSON ARON FUMBO Tarehe 6/12/24 saa 10:29 AM Jumla ya Ada TshXXX (M-Pesa Ada TshXXX + TOZO ya Serikali TshXXX). Salio lako ni TshXXX.  ......`;
            } else if (this.countryInfo?.enName === "TZ") {
                return `payment SMS example:
BL6XXXXXNFA Imethibitishwa TshXXX imetumwa kwa 255XXXXXX160 - MATSON ARON FUMBO Tarehe 6/12/24 saa 10:29 AM Jumla ya Ada TshXXX (M-Pesa Ada TshXXX + TOZO ya Serikali TshXXX). Salio lako ni TshXXX.  ......`;
            } else if (this.countryInfo?.enName === "UG") {
                return "You have sent UGX xxx to xxx xxx, 256xxxxx9263 on 0000-00-00 00:00:00, fee: 0. Reason: Testing. New balance: xxx. ID :302xxxxx057.";
            } else if (this.countryInfo?.enName === "ET") {
                if (bankName && this.formatBankName(bankName).toLowerCase() == "mpesa") {
                    return "Dear XX, you have sent ** Birr to XX 251706***140 on **/**/** at **:** AM. Transaction number TJE****LA5. Transaction fee ** Birr. Your current M-PESA balance is *** Birr..."
                } else if (bankName && this.formatBankName(bankName).toLowerCase() == "telecom") {
                // } else if (bankName && this.formatBankName(bankName).toLowerCase() == "telebirr") {
                    return "Dear XX You have transferred ETB ** to XX (0963****91) on **/**/** **:**:**. Your transaction number is CJE****01F. The service fee is ETB ** and 15% VAT on the service fee is ETB **. Your current E-Money Account balance is ETB *** ..."
                }
            } else if (this.countryInfo?.enName === "TD") {
                if (bankName && this.formatBankName(bankName).toLowerCase() == "airtel") {
                    return "TID: PP251127.****.A62513. Vous avez recu *** FCFA de  XXX,63****86. Votre solde est *** FCFA"
                } else if (bankName && this.formatBankName(bankName).toLowerCase() == "moov") {
                // } else if (bankName && this.formatBankName(bankName).toLowerCase() == "telebirr") {
                    return "Transfert confirme de **** FCFA a XXX XXX(23596****08) le **-**-**** 23:59:59.\n" +
                        "Frais:*** FCFA Votre nouveau solde est de *** FCFA. Ref: CKR****DZN"
                }
            } else if (this.countryInfo?.enName === "ML") {
                if (bankName && this.formatBankName(bankName).toLowerCase() == "orange") {
                    return "Your transfer of *** FCFA to 77***938 is success. Fee is ** FCFA. Your new balance is *** FCFA. ID : PP251202.****.D08833. OFM MALI"
                } else if (bankName && this.formatBankName(bankName).toLowerCase() == "moov") {
                    return "Transfert d'argent reussi vers 22360***037,Montant: *** FCFA,Frais: 0,00 FCFA,Fond de Soutien FSIDS : 0,00 FCFA,Total: *** FCFA,ID: CASHT******EGEV,Solde: **** FCFA."
                }
            } else if (this.countryInfo?.enName === "NE") {
                if (bankName && this.formatBankName(bankName).toLowerCase() == "airtel") {
                    return "Vous avez envoye *** FCFA a 98****63 Cout *FCFASolde ***FCFA. Numero de transaction PP260210.****.J04432"
                } else if (bankName && this.formatBankName(bankName).toLowerCase() == "orange") {
                    return "Votre transfert de *** FCFA vers le 81****96 a reussi. Frais de transfert : ** FCFA. Votre nouveau solde est de *** FCFA"
                } else if (bankName && this.formatBankName(bankName).toLowerCase() == "moov") {
                    return "Vous avez envoye *** FCFA au numero 22784****18.Cout de la transaction * FCFA. Votre nouveau solde Moov est de *** FCFA. Ref :22026*****00801."
                } else if (bankName && this.formatBankName(bankName).toLowerCase() == "mynita") {
                    return "Reçu envoi compte à compte :\n" +
                        "     Montant transaction:  **,\n" +
                        "      Nom Expediteur:  XXX ,\n" +
                        "      Prenom Expediteur: XX,\n" +
                        "      Telephone Expediteur: 002278****756,\n" +
                        "      codeEnvoi: MYNITA********7CEC3,\n" +
                        "      Nom Destinateur: XX ,\n" +
                        "      Prenom Destinateur: XX XX ,\n" +
                        "      Telephone Destinataire: 002******1800,\n" +
                        "      Date de Transaction: 20**-**-** **:**,"
                }
            } else if (this.countryInfo?.enName === "MZ") {
                console.log("11111111111111",bankName && this.formatBankName(bankName).toLowerCase())
                if (bankName && this.formatBankName(bankName).toLowerCase() == "mpesa") {
                    return "DE7****6GLW Confirmed. **MT sent and the fee was 0.00MT to 857****57 -XXX on */*/** at **:** AM. New M-Pesa balance is **MT. Keep sending money FREE OF CHARGE from M-Pesa to M-Pesa. In case of doubt, call 100."
                } else if (bankName && this.formatBankName(bankName).toLowerCase() == "emola") {
                    return "Transaction ID PP2605**.****.**3006. You transfered **MT to 879****39, name: XX at **:**:** on **/**/20**. Fee: 0.00MT. Your account balance is **MT. Content: tra. In case of doubt, please call 100. Thank you!"
                }
            } else if (this.countryInfo?.enName === "SL") {
                console.log("11111111111111",bankName && this.formatBankName(bankName).toLowerCase())
                if (bankName && this.formatBankName(bankName).toLowerCase() == "africell") {
                    return "Money transfer successful Amount:** NLE To:099****07 Charges:0.0 NLE Tax: 0 NLE Date:20**-**-**T23:59:59+0000 New balance:** NLE Trans.ID:PP2605**.****.**6869"
                } else if (bankName && this.formatBankName(bankName).toLowerCase() == "orange") {
                    return "Transaction Id: PP260522.****.***615 Transfer Successful to 75****34 XX of transaction amount: **, charges:**, GST: **. Net debit amount :**, your new balance is: 00."
                }
            } else if (this.countryInfo?.enName === "EG") {
                console.log("11111111111111",bankName && this.formatBankName(bankName).toLowerCase())
                if (bankName && this.formatBankName(bankName).toLowerCase() == "vodafone") {
                    return "تم تحويل ** جنيه لرقم 0103****0103 مصاريف الخدمة 1 جنيه رصيد حسابك فى فودافون كاش الحالي **. تاريخ العملية **:** **-**-** : رقم العملية 123****02065 : حول فلوسك أسرع وأسهل من خلال تطبيق أنا فودافون، وتحكم في معاملاتك من خلال http://vf.eg/vfcash"
                }
            } else {
                return "";
            }
        },
        handleBallClick() {
            const currentLang = this.$i18n.locale;
            const supportedLangs = this.supportedLanguages;

            if (supportedLangs.length === 0) return;

            // 获取当前语言在支持列表中的索引
            const currentIndex = supportedLangs.indexOf(currentLang);
            // 计算下一个语言的索引
            const nextIndex = (currentIndex + 1) % supportedLangs.length;
            const nextLang = supportedLangs[nextIndex];

            setI18nLanguage(nextLang, this);
        },
        initDriver() {
            this.driver = driver({
                animate: true,
                allowClose: true,
                doneBtnText: this.$t("text_finish"),
                nextBtnText: this.$t("text_next_step"),
                prevBtnText: this.$t("text_previous"),
                showProgress: true,
                showButtons: ["next", "previous"],
                steps: [
                    {
                        element: () => this.$refs.accountStep,
                        popover: {
                            title: this.$t("text_step1"),
                            description: `${this.$t("text_step1_text1")}<br>${this.$t(
                                "text_step1_text2"
                            )}`, // 使用<br>换行
                            side: "top",
                        },
                    },
                    {
                        element: () => this.$refs.refreshStep,
                        popover: {
                            title: this.$t("text_step2"),
                            description: `${this.$t("text_step2_text2")}`,
                            side: "top",
                        },
                    },
                ],
                onNextClick: () => {
                    console.log("onNext");
                    if (this.driver.hasNextStep()) {
                        this.driver.moveNext();
                    } else {
                        this.driver.destroy();
                    }
                },
                onPrevClick: () => {
                    console.log("onPrevious");
                    if (this.driver.hasPreviousStep()) {
                        this.driver.movePrevious();
                    }
                },
                onDestroyed: () => {
                    // 引导结束后的处理
                    console.log("Tour completed2");
                    sessionStorage.setItem("showDrive", "1");
                },
                onPopoverRender: (popover, options) => {
                    console.log("popover options", popover, options);
                },
            });
        },
        startGuide() {
            // if (this.isShowDriver){
            if (this.isShowDriver || sessionStorage.getItem("showDrive")) {
                return;
            }
            if (this.driver) {
                this.driver.drive();
                this.isShowDriver = true;
            }
        },
        formatBankName(str) {
            if (str) {
                if (str.endsWith("_agent")) {
                    str = str.split("_")[0] + "_" + str.split("_")[2];
                } else if (str.includes("_")) {
                    str = str.split("_")[0];
                }
                str = str.toLocaleUpperCase();
            }
            return str;
        },
        containsPunctuation(str) {
            // 定义一个正则表达式，匹配常见的标点符号
            const punctuationRegex = /[!.,;:?"'(){}[\]<>@#$%^&*+=~`|\\/]/;
            return punctuationRegex.test(str);
        },
        async transactionIdSubmit() {
            if (!this.transactionIdTemplate) {
                this.$toast(this.$t("text_please_enter_payment_sms"));
                return;
            }
            const params = {
                trxNo: this.repaymentData.sdkChannelRespDetailVO.repaymentCode,
                paymentSmsContent: this.transactionIdTemplate,
                platformReference: this.$route.params.platformReference,
            };

            const res = await this.$http.checkoutParseTxId(params);
            this.transactionId = res.data || this.transactionIdTemplate;
            this.transactionIdSubmitTwo();
        },
        async transactionIdSubmitTwo() {
            if (!this.transactionId) {
                this.$toast(this.$t("text_please_enter_transaction_id"));
                return;
            }

            const transactionId = this.transactionId.trim();
            let res = await this.$http.checkoutSubmitTxId({
                trxNo: this.repaymentData.sdkChannelRespDetailVO.repaymentCode,
                platformReference: this.$route.params.platformReference,
                transactionId,
            });
            if (res.code == "200") {
                await this.$http.checkoutTxIdMatch({
                    trxNo: this.repaymentData.sdkChannelRespDetailVO.repaymentCode,
                    platformReference: this.$route.params.platformReference,
                    transactionId,
                });
                this.isSubmitTransactionId = true;
                this.transactionIdTemplateShow = false;
                this.$emit("refreshData");
            }
        },
        onTransactionIdSubmitClick() {
            throttleClick(this, "transactionIdSubmit", () => this.transactionIdSubmit());
        },
        onTransactionIdSubmitTwoClick() {
            throttleClick(this, "transactionIdSubmitTwo", () => this.transactionIdSubmitTwo());
        },
        onOpenPaymentAccountVerifyClick() {
            throttleClick(this, "openPaymentAccountVerify", () => this.openPaymentAccountVerify());
        },
        onPaymentAccountVerifySubmitClick() {
            throttleClick(this, "paymentAccountVerifySubmit", () => this.paymentAccountVerifySubmit());
        },
        onSubmitEditTrxNoClick() {
            throttleClick(this, "submitEditTrxNo", () => this.submitEditTrxNo());
        },
        openPaymentAccountVerify() {
            if (Date.now() > 1) {
                this.paymentAccountVerifySubmit();
                return;
            }
            let obj = this.operatorList.find((v) => v.isSelect);
            if (!obj) {
                this.$toast(this.$t("text_please_select_operator_first"));
                return;
            }
            this.userSubmitOperator = obj.name;

            if (!this.paymentAccount) {
                this.$toast(this.$t("text_please_enter_payment_account_number"));
                return;
            }

            let userSubmitAccountNumber = this.paymentAccount;
            if (!this.checkPhone(userSubmitAccountNumber)) {
                this.$toast(this.$t("text_mobile_phone_number_format_incorrect"));
                return;
            }

            if (
                this.countryInfo?.enName === "BJ" &&
                !this.checkPhoneRegex(userSubmitAccountNumber)
            ) {
                this.$toast(this.$t("text_mobile_phone_number_format_incorrect"));
                return;
            }

            //   if(userSubmitAccountNumber.startsWith("0")){
            //     userSubmitAccountNumber = userSubmitAccountNumber.substring(1);
            //   }
            userSubmitAccountNumber = this.zeroFill(userSubmitAccountNumber);
            userSubmitAccountNumber = userSubmitAccountNumber.trim();
            // userSubmitAccountNumber = "233" + userSubmitAccountNumber;
            this.userSubmitAccountNumber = userSubmitAccountNumber;

            this.popCommitText = this.$t("text_confirm");
            this.countdown();
            this.paymentAccountVerifyShow = true;
        },
        paymentAccountVerifyReturn() {
            this.popCommitText = this.$t("text_confirm");
            this.paymentAccountVerifyShow = false;
            this.paymentAccountShow = true;
        },
        paymentAccountVerifySubmit() {
            this.paymentAccountSubmit();
        },
        // 弹窗倒计时
        countdown() {
            let intFunc = () => {
                if (this.timerOut >= 1) {
                    this.popCommitText = `${this.$t("text_confirm")}(${this.timerOut}s)`;
                    this.timerOut--;
                } else {
                    clearInterval(this.timer);
                    this.popCommitText = this.$t("text_confirm");
                    this.timerOut = 3;
                }
            };
            intFunc();
            this.timer = setInterval(intFunc, 1000);
        },
        realFocus(str) {
            if (str == "operator") {
                this.operatorPopup = true;
            }
        },
        operatorChange(value) {
            this.operator = value.text;
            this.operatorValue = value.value;
            this.operatorPopup = false;
        },
        chooseOperator(index) {
            if (this.operatorList.find((v) => v.isSelect)) this.paymentAccount = "";
            this.operatorList.map((v) => {
                v.isSelect = false;
                return v;
            });
            this.operatorList[index].isSelect = true;
        },
        async getResults() {
            this.debounce(this.resultFunc, 1000, true)();
        },
        async resultFunc() {
            await this.$http.checkoutTxIdMatch({
                trxNo: this.repaymentData.sdkChannelRespDetailVO.repaymentCode,
                platformReference: this.$route.params.platformReference,
                transactionId: this.transactionId,
            });

            this.getResultsMed();
        },
        async refresh() {
            await this.getResultsMed();
            if (this.syncCustomBlueSuccessPage()) {
                return;
            }
            if (!["BJ", "BF", "ID", "TH", "GH"].includes(this.countryInfo?.enName)) {
                if (this.collectionDataStep == 0) {
                    this.refreshNum = 1;
                } else if (this.collectionDataStep == 1) {
                    this.refreshNum = 0;
                }
            } else {
                if (this.collectionDataStep == 0) {
                    this.showError = true;
                } else {
                    this.showError = false;
                }
            }
        },
        async getCollectedDetail() {
            await this.$http.checkoutTxIdMatch({
                trxNo: this.repaymentData.sdkChannelRespDetailVO.repaymentCode,
                platformReference: this.$route.params.platformReference,
                transactionId: this.transactionId,
            });
            let res = await this.$http.checkoutPayResult({
                trxNo: this.repaymentData.sdkChannelRespDetailVO.repaymentCode,
                platformReference: this.$route.params.platformReference,
            });
            if (res.code == "200") {
                this.collectionData = res.data;
                this.repaymentData.cardData.collectedAmount =
                    this.collectionData.collectedAmount;
                if (this.collectionData.collectDetails.length == 0) {
                    if (this.isPaymentAccountEntryPageTheme) {
                        this.collectionDataStep = 0;
                        this.collectionShow = true;
                        return;
                    }
                    this.$toast("No details yet");
                    return;
                }
                if (
                    this.collectionData.collectedAmount == 0 &&
                    this.collectionData.transactionNums == 0
                ) {
                    this.collectionDataStep = 0;
                } else {
                    this.collectionDataStep = 1;
                }
                // this.collectionShow = true;
                this.collectionDetailShow = true;
            }
        },
        async editAccountSubmit() {
            if (!this.editAccountNumber) {
                this.$toast("Please enter payment account number");
            }

            let editAccountNumber = this.editAccountNumber;
            if (!this.checkPhone(editAccountNumber)) {
                this.$toast("The mobile phone number format is incorrect");
                return;
            }
            //   if(editAccountNumber.startsWith("0")){
            //     editAccountNumber = editAccountNumber.substring(1);
            //   }
            editAccountNumber = this.zeroFill(editAccountNumber);
            editAccountNumber = editAccountNumber.trim();
            // editAccountNumber = "233" + editAccountNumber;
            this.editAccountNumber = editAccountNumber;
            if (
                this.repaymentData.cardData.userSubmitAccountNumber ==
                this.editAccountNumber
            ) {
                this.$toast("The new number cannot be the same as the old one!");
                return;
            }
            this.editAccountConfirmShow = true;
            // this.debounce(this.submitTrxNo, 1000)();
            // this.submitEditTrxNo();
        },
        async submitEditTrxNo() {
            let res = await this.$http.checkoutPaymentAccount({
                originAccountNumber:
                this.repaymentData.cardData.userSubmitAccountNumber,
                editAccountNumber: this.editAccountNumber,
                trxNo: this.repaymentData.sdkChannelRespDetailVO.repaymentCode,
                platformReference: this.$route.params.platformReference,
            });
            if (res.code == "200") {
                await this.$http.checkoutReverseMatch({
                    userSubmitAccountNumber: this.editAccountNumber,
                    trxNo: this.repaymentData.sdkChannelRespDetailVO.repaymentCode,
                    platformReference: this.$route.params.platformReference,
                });
                this.$toast("Modified successfully");
                this.editAccountShow = false;
                this.editAccountConfirmShow = false;
                this.$emit("refreshData");

                this.startGuide();
            }
            console.log(res);
        },
        async paymentAccountSubmit() {
            console.log("111111")
            if (this.operatorList.length) {
                let obj = this.operatorList.find((v) => v.isSelect);
                if (!obj) {
                    this.$toast(this.$t("text_please_select_operator_first"));
                    return;
                }
                this.userSubmitOperator = obj.name;
            }
            console.log("3333333333333333")
            if (this.repaymentData.extraParams.includes("customerAccountNumber")) {
                if (!this.paymentAccount) {
                    this.$toast(this.$t("text_please_enter_payment_account_number"));
                    return;
                }
            }
            console.log("6666666666666")

            let userSubmitAccountNumber = this.paymentAccount;
            if (!this.checkPhone(userSubmitAccountNumber)) {
                this.$toast(this.$t("text_mobile_phone_number_format_incorrect"));
                return;
            }
            console.log("44444444444444")
            userSubmitAccountNumber = this.zeroFill(userSubmitAccountNumber);
            userSubmitAccountNumber = userSubmitAccountNumber.trim();
            this.userSubmitAccountNumber = userSubmitAccountNumber;

            console.log("2222222222")
            this.submitTrxNo();
        },
        async submitTrxNo() {
            let obj = this.operatorList.find((v) => v.isSelect);
            let res = await this.$http.v1SdkSysInitialize({
                paymentAccountNumber: this.userSubmitAccountNumber,
                platformReference: this.$route.params.platformReference,
                customerBankCode: obj ? obj.value : undefined,
            });
            if (res.code == "200") {
                this.$http.checkoutSubmit({
                    userSubmitAccountNumber: this.userSubmitAccountNumber,
                    trxNo: res.data.repaymentCode,
                    platformReference: this.$route.params.platformReference,
                    bankCode: obj ? obj.value : undefined,
                });
                this.popCommitText = this.$t("text_confirm");
                this.paymentAccountVerifyShow = false;
                this.paymentAccountShow = false;
                // this.paymentAccountVerifyReturn();
                this.$emit("refreshData");
            }
            console.log(res);
        },
        onCopy(str) {
            let url = str;
            let oInput = document.createElement("input");
            oInput.value = url;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            console.log(oInput.value);
            document.execCommand("Copy"); // 执行浏览器复制命令
            this.$toast(this.$t("text_successful_replication"));
            oInput.remove();
        },
        futureDay() {
            clearTimeout(this.setTimeoutID);
            // console.log("futureDay", this.pageData.remainTime)
            const msec = Number(this.pageData.remainTime);
            if (!Number.isFinite(msec)) {
                return;
            }
            this.pageData.remainTime = msec - 1000;
            let day = parseInt(msec / 1000 / 60 / 60 / 24);
            let hr = parseInt((msec / 1000 / 60 / 60) % 24) + day * 24;
            let min = parseInt((msec / 1000 / 60) % 60);
            let sec = parseInt((msec / 1000) % 60);
            // console.log(hr, min, sec)
            hr > 99 ? (hr = 99) : hr;
            if (Object.is(hr, NaN) || Object.is(min, NaN) || Object.is(sec, NaN)) {
                hr = 0;
                min = 0;
                sec = 0;
            }
            hr = hr < 0 ? 0 : hr;
            min = min < 0 ? 0 : min;
            sec = sec < 0 ? 0 : sec;
            // this.day = day
            this.hr = hr > 9 ? hr : "0" + hr;
            this.min = min > 9 ? min : "0" + min;
            this.sec = sec > 9 ? sec : "0" + sec;

            // this.repaymentData.day = this.day;
            this.repaymentData.hr = this.hr;
            this.repaymentData.min = this.min;
            this.repaymentData.sec = this.sec;
            if (hr == 0 && min == 0 && sec == 0) {
                clearTimeout(this.setTimeoutID);
                this.$emit("expired");
                return;
            }
            this.setTimeoutID = setTimeout(() => {
                this.futureDay();
            }, 1000);
        },
        zeroFill(value) {
            // if (["CM"].includes(this.countryInfo?.enName)){
            //     return value;
            // }
            value = value.replace(" ", "");

            if (this.countryInfo?.enName === "SN") {
                if (value.startsWith("0")) {
                    return value.substring(1);
                }
                return value;
            }

            if (/^\d+$/.test(value)) {
                if (this.countryInfo?.enName === "EG") {
                    if (value.length == 10 && value[0] != 0) {
                        value = "0" + value;
                    }
                } else if (value.length == 9 && value[0] != 0) {
                    value = "0" + value;
                }
            }
            return value;
        },
        processNumberString(value) {
            if (!["BF", "TD", "ML", "NE"].includes(this.countryInfo?.enName)) return value;
            // 检查是否有值
            if (value == null || value === "") {
                return value;
            }

            // 检查是否为字符串
            if (typeof value !== "string") {
                return value;
            }

            // 检查是否为纯数字
            if (!/^\d+$/.test(value)) {
                return value;
            }

            // TD国家不去0，直接返回原值
            if (this.countryInfo?.enName === "TD") {
                return value;
            }

            // 处理8位数字
            if (value.length === 8) {
                return value;
            }

            // 处理9位数字
            if (value.length === 9) {
                return value.charAt(0) === "0"
                    ? value.substring(1) // 首位是0则去掉
                    : value; // 否则返回完整9位
            }

            // 其他情况返回原始值
            return value;
        },
        checkPhone(value) {
            if (!this.repaymentData.extraParams.includes("customerAccountNumber")) {
                return true;
            }
            value = value.replace(" ", "");
            if (/^\d+$/.test(value)) {
                if (["BF", "TD", "ML", "NE", "SL"].includes(this.countryInfo?.enName)) {
                    if (value.length == 9 && value[0] == 0) {
                        return true;
                    } else if (value.length == 8) {
                        return true;
                    }
                } else if (this.countryInfo?.enName === "EG") {
                    // 加0：11位数，不加0：10位数
                    if (value.length == 11 && value[0] == 0) {
                        return true;
                    } else if (value.length == 10 && value[0] != 0) {
                        return true;
                    }
                } else {
                    if (value.length == 10 && value[0] == 0) {
                        return true;
                    } else if (value.length == 9 && value[0] != 0) {
                        return true;
                    }
                }
            }
            return false;
        },
        // 专门用于回显时的格式校验，不依赖 extraParams
        validateAccountNumberFormat(value) {
            if (!value) return false;
            value = value.replace(" ", "");
            if (!/^\d+$/.test(value)) return false;
            
            // 根据国家进行格式校验
            if (["BF", "TD", "ML", "NE", "SL"].includes(this.countryInfo?.enName)) {
                // 加0：9位数，不加0：8位数
                if (value.length == 9 && value[0] == 0) {
                    return true;
                } else if (value.length == 8) {
                    return true;
                }
                return false;
            } else if (this.countryInfo?.enName === "EG") {
                // 加0：11位数，不加0：10位数
                if (value.length == 11 && value[0] == 0) {
                    return true;
                } else if (value.length == 10 && value[0] != 0) {
                    return true;
                }
                return false;
            } else {
                // 其他国家的格式：加0：10位数，不加0：9位数
                if (value.length == 10 && value[0] == 0) {
                    return true;
                } else if (value.length == 9 && value[0] != 0) {
                    return true;
                }
                return false;
            }
        },
        checkPhoneRegex(value) {
            const prefixList = [
                "0142",
                "0146",
                "0150",
                "0151",
                "0152",
                "0153",
                "0154",
                "0156",
                "0157",
                "0159",
                "0161",
                "0162",
                "0166",
                "0167",
                "0169",
                "0190",
                "0191",
                "0196",
                "0197",
                "0145",
                "0155",
                "0158",
                "0160",
                "0163",
                "0164",
                "0165",
                "0168",
                "0194",
                "0195",
                "0198",
                "0199",
            ];

            // 创建去零前缀列表（用于9位账户校验）
            const prefixListWithoutZero = prefixList.map((prefix) =>
                prefix.substring(1)
            );
            console.log("11111111111");
            // 检查是否为数字字符串
            if (!/^\d+$/.test(value)) {
                return false;
            }
            console.log("22222222222");

            // 情况1: 0开头的10位数字
            if (value.startsWith("0") && value.length === 10) {
                const prefix = value.substring(0, 4);
                console.log("prefix1", prefix, prefixList.includes(prefix));
                return prefixList.includes(prefix);
            }
            // 情况2: 非0开头的9位数字
            else if (!value.startsWith("0") && value.length === 9) {
                const prefix = value.substring(0, 3);
                console.log("prefix2", prefix, prefixListWithoutZero.includes(prefix));
                return prefixListWithoutZero.includes(prefix);
            }

            // 其他情况均无效
            return false;
        },
        debounce(func, delay = 1000, immediate = true) {
            let _this = this;
            //不能用箭头函数
            return function () {
                //在时间内重复调用的时候需要清空之前的定时任务
                if (_this.timer) {
                    clearTimeout(_this.timer);
                }
                //适用于首次需要立刻执行的
                if (immediate && !_this.timer) {
                    func.apply(this, arguments);
                }
                _this.timer = setTimeout(() => {
                    func.apply(this, arguments);
                }, delay);
            };
        },
        formatDecimal(str, decimalPlaces) {
            if (decimalPlaces == null) return str;

            const match = str.match(/^(-?)(\d*)(?:\.(\d*))?$/);
            if (!match) return str;

            const sign = match[1];
            let integerPart = match[2] || "0";
            let decimalPart = match[3] || "";

            // 处理保留 0 位小数的情况
            if (decimalPlaces === 0) {
                return sign + integerPart; // 正确返回整数部分
            }

            // 截断或补零
            if (decimalPart.length > decimalPlaces) {
                decimalPart = decimalPart.substring(0, decimalPlaces);
            } else {
                decimalPart = decimalPart.padEnd(decimalPlaces, "0");
            }

            return sign + integerPart + "." + decimalPart;
        },
        removeLeadingZeros(str) {
            if (!str) return str; // 空字符串直接返回

            // 处理负数情况
            const isNegative = str.startsWith("-");
            const numStr = isNegative ? str.substring(1) : str;

            // 查找第一个非0字符的位置
            let firstNonZeroIndex = 0;
            while (
                firstNonZeroIndex < numStr.length &&
                numStr[firstNonZeroIndex] === "0"
                ) {
                firstNonZeroIndex++;
            }

            // 处理全0情况
            const result =
                firstNonZeroIndex === numStr.length
                    ? "0"
                    : numStr.substring(firstNonZeroIndex);

            return isNegative ? "-" + result : result;
        },
        formatNumberString(input) {
            // 检查输入是否为字符串
            if (typeof input !== 'string') {
                return input;
            }

            // 检查是否只包含数字
            if (!/^\d+$/.test(input)) {
                return input;
            }

            // 检查长度
            const length = input.length;
            if (length === 9) {
                return input;
            } else if (length === 10) {
                // 去掉开头的0
                return input.startsWith('0') ? input.substring(1) : input;
            } else {
                return input;
            }
        },
        async init() {
            this.futureDay();
            this.getCardInfo();
        },
        async getCardInfo() {
            if (this.repaymentData?.sdkChannelRespDetailVO?.repaymentCode) {
                let res = await this.$http.checkoutInfo({
                    trxNo: this.repaymentData.sdkChannelRespDetailVO.repaymentCode,
                    platformReference: this.$route.params.platformReference,
                });
                // res.data.accountNumber = this.removeLeadingZeros(res.data.accountNumber)
                res.data.amount = this.formatDecimal(
                    res.data.amount,
                    this.currentBankInfo?.decimalPlaces
                );

                if (["SN", "MZ"].includes(this.countryInfo?.enName) && res.data.accountNumber) {
                    let accNum = String(res.data.accountNumber);
                    if (accNum.startsWith("0")) {
                        res.data.accountNumber = accNum.substring(1);
                    }
                }

                if (["BF", "TD", "ML", "NE"].includes(this.countryInfo?.enName)) {
                    res.data.accountNumber = this.processNumberString(
                        res.data.accountNumber
                    );
                }
                this.$set(this.repaymentData, 'cardData', res.data);
                // this.repaymentData.cardData.tipsContent = `<p>hahahahahaha<strike>hahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahaha</strike>hahaha<u>hahahahahahaha</u>hahahahahahahahahahahahahahahah<span style="font-size: 24px;">ahahahahahahahahahahahahah</span>ahahahahahahahahahahahahahahahahahahaha</p>`;
                // this.repaymentData.cardData.tipsContent = "";
                if (["CM"].includes(this.countryInfo?.enName)) {
                    this.repaymentData.cardData.accountNumber = this.formatNumberString(res.data.accountNumber)
                    this.repaymentData.cardData.userSubmitAccountNumber = this.formatNumberString(res.data.userSubmitAccountNumber)
                }

                this.startGuide();

                if (this.repaymentData?.cardData?.transactionId) {
                    this.isSubmitTransactionId = true;
                    this.transactionId = this.repaymentData?.cardData?.transactionId;
                    this.transactionIdTemplate =
                        this.repaymentData?.cardData?.paymentSmsContent;
                }
                if (!this.repaymentData?.cardData?.accountNumber) {
                    if (!this.intervalID) {
                        this.intervalID = setInterval(() => {
                            this.getCardInfo();
                        }, 1000);
                    }
                    setTimeout(() => {
                        if (this.intervalID) clearInterval(this.intervalID);
                        this.intervalID = "";
                    }, 3000);
                } else {
                    if (this.intervalID) clearInterval(this.intervalID);
                    this.intervalID = "";
                }
                console.log("checkoutInfo", res);
                if (res.code != 200) {
                    if (this.intervalID) clearInterval(this.intervalID);
                    this.$emit("showPopup");
                } else {
                    this.getResultsMed();
                }
            }
        },
        syncCustomBlueSuccessPage() {
            if (this.isCustomBlueTheme && this.collectionDataStep == 1) {
                this.showCustomBlueSuccessPage = true;
                return true;
            }
            return false;
        },
        async getResultsMed() {
            return new Promise((resolve) => {
                this.$http
                    .checkoutPayResult({
                        trxNo: this.repaymentData.sdkChannelRespDetailVO.repaymentCode,
                        platformReference: this.$route.params.platformReference,
                    })
                    .then((res) => {
                        if (res.code == "200") {
                            this.collectionData = res.data;
                            this.repaymentData.cardData.collectedAmount =
                                this.collectionData.collectedAmount;
                            if (
                                this.collectionData.collectedAmount == 0 &&
                                this.collectionData.transactionNums == 0
                            ) {
                                this.collectionDataStep = 0;
                            } else {
                                this.collectionDataStep = 1;
                                // 当支付成功时，重置错误提示状态
                                this.refreshNum = 0;
                                this.showError = false;
                                this.syncCustomBlueSuccessPage();
                            }
                            // this.collectionShow = true;
                            // this.collectionDetailShow = true;
                            console.log("this.collectionDataStep", this.collectionDataStep);

                            // this.collectionData.collectedAmount = 100;
                            // this.collectionDataStep = 1;
                            // this.refreshNum = 2;
                        }
                    })
                    .finally(() => {
                        resolve();
                    });
            });
        },
        isPayParam() {
            return this.$route.query.from === "pay";
        },
        updateCode() {
            if (this.repaymentData?.configData?.countryInfoVO?.enName == "BJ") {
                this.repaymentData.configData.countryInfoVO.currencyCode = "FCFA";
            } else if (this.repaymentData?.configData?.countryInfoVO?.enName == "TH") {
                this.repaymentData.configData.countryInfoVO.currencyCode = "฿";
            } else if (this.repaymentData?.configData?.countryInfoVO?.enName == "TD") {
                this.repaymentData.configData.countryInfoVO.currencyCode = "FCFA";
            } else if (this.repaymentData?.configData?.countryInfoVO?.enName == "ML") {
                this.repaymentData.configData.countryInfoVO.currencyCode = "FCFA";
            } else if (this.repaymentData?.configData?.countryInfoVO?.enName == "NE") {
                this.repaymentData.configData.countryInfoVO.currencyCode = "FCFA";
            } else if (this.repaymentData?.configData?.countryInfoVO?.enName == "MZ") {
                this.repaymentData.configData.countryInfoVO.currencyCode = "MT";
            } else if (this.repaymentData?.configData?.countryInfoVO?.enName == "SL") {
                this.repaymentData.configData.countryInfoVO.currencyCode = "SLE";
            }
        }
    },
    mounted() {
        this.repaymentData = this.pageData;
        console.log("this.repaymentData", this.repaymentData)
        // this.repaymentData.configData.countryInfoVO.enName = "GH";
        this.updateCode();
        // if (!["BJ", "BF", "TH"].includes(this.repaymentData?.configData?.countryInfoVO?.enName)) {
        //     this.$nextTick(() => {
        //         this.initDriver();
        //     })
        // }
        this.setLanguageBasedOnCountry(
            this.repaymentData?.configData?.countryInfoVO?.enName
        );
        if (this.repaymentData?.configData?.checkoutConfigInfoVOList?.mnoInfos?.length) {
            this.repaymentData?.configData?.checkoutConfigInfoVOList.mnoInfos.forEach((v) => {
                this.operatorList.push({
                    name: v.bankInfoVO.bankName,
                    value: v.bankInfoVO.bankCode,
                    logo: v.bankInfoVO.bankIcon,
                    isSelect: false,
                    decimalPlaces: v.decimalPlaces,
                });
            });
            // 如果只有一个选项，自动选中
            if (this.operatorList.length === 1) {
                this.operatorList[0].isSelect = true;
            } 
            // 如果有多个选项，且接口返回了 bankCode，则根据 bankCode 设置默认选中项
            else if (this.repaymentData?.paymentData?.bankCode) {
                const bankCode = this.repaymentData.paymentData.bankCode;
                const matchedOperator = this.operatorList.find((v) => v.value === bankCode);
                if (matchedOperator) {
                    matchedOperator.isSelect = true;
                }
            }
        }
        if (!this.repaymentData.paymentData.paymentAccountNumber) {
            // 回显前先校验格式，格式不对就不回显
            if (this.repaymentData.paymentData.customerAccountNumber) {
                const accountNumber = this.repaymentData.paymentData.customerAccountNumber;
                // 回显时强制校验格式，不依赖 extraParams
                if (this.validateAccountNumberFormat(accountNumber)) {
                    this.paymentAccount = accountNumber;

                    let userSubmitAccountNumber = accountNumber;
                    userSubmitAccountNumber = this.zeroFill(userSubmitAccountNumber);
                    userSubmitAccountNumber = userSubmitAccountNumber.trim();
                    this.userSubmitAccountNumber = userSubmitAccountNumber;
                }
                // 格式不对就不回显，不执行任何操作
            }
            // else {
            // this.paymentAccount = "0000000000";
            // this.userSubmitAccountNumber = "0000000000";
            // }

            // this.paymentAccountSubmit();

            //   if(this.isPayParam()){
            //     if (this.userSubmitAccountNumber){
            //       this.isInitVerify = true;
            //       this.paymentAccountSubmit();
            //     }else{
            //       this.paymentAccountShow = true;
            //     }
            //   }else{
            // console.log("11111111111111111111")
            // if (this.repaymentData.extraParams.includes("customerBankCode") || this.repaymentData.extraParams.includes("customerAccountNumber")) {
            //     this.paymentAccountShow = true;
            //     console.log("33333333333")
            //     // this.carrierSelectionShow = true;
            // } else {
            //     this.paymentAccountSubmit();
            //     console.log("4444444444444444")
            // }

            if (["TH"].includes(this.repaymentData?.configData?.countryInfoVO?.enName)) {
                this.paymentAccountSubmit();
            } else if (this.repaymentData.extraParams.includes("customerAccountNumber") || this.repaymentData.extraParams.includes("customerBankCode")) {
                this.paymentAccountShow = true;
            } else {
                this.paymentAccountSubmit();
            }
            //   }
        } else {
            if (["TH"].includes(this.repaymentData?.configData?.countryInfoVO?.enName)) {
                this.paymentAccountSubmit();
            } else if (this.repaymentData.extraParams.includes("customerAccountNumber") || this.repaymentData.extraParams.includes("customerBankCode")) {
                this.paymentAccountShow = true;
            } else {
                this.paymentAccountSubmit();
            }
        }

        this.init();
        applyCustomBlueSuccessDebug(this);
    },
    beforeDestroy() {
        clearTimeout(this.setTimeoutID);
        this.setTimeoutID = null;
    },
};
